<div fxLayout="row">
  @if (!hideChips) {
    <chip-collection [chips]="chips" (click)="$event.stopPropagation()" aria-label="ChipCollection-NoteAndAttachment-AdvancedComponents">
    </chip-collection>
  }

  @if (hasCommands) {
    <command-menu [commands]="commands" icon="more_vert">
    </command-menu>
  }
</div>